module.exports = __webpack_public_path__ + "img/Escudo-logo.246b05e0.svg";